export const BLIK_MODEL = {
  model0: 'BLIK_MODEL_O',
  modelM: 'BLIK_MODEL_M'
}

export const BLIK_ERROR = {
  recurrencyNotSupported: 'RECURRENCY_NOT_SUPPORTED',
  wrongTicket: 'WRONG_TICKET'
}

export const BLIK_RECURRING_ACTION = {
  initWithoutPayment: 'INIT_WITHOUT_PAYMENT',
  initWithPayment: 'INIT_WITH_PAYMENT',
  initWithRefund: 'INIT_WITH_REFUND'
}
